export default __webpack_public_path__ + "media/Edit.398b32a2.svg";